"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BaseButton_1 = __importDefault(require("../../atoms/buttons/BaseButton"));
const Avatar_1 = __importDefault(require("../../atoms/misc/Avatar"));
const clsx_1 = __importDefault(require("clsx"));
function AvatarButton({ title, action, avatar, ...props }) {
    return (react_1.default.createElement("div", { className: "flex flex-shrink-0 p-4 border-t border-gray-200 dark:border-gray-800" },
        react_1.default.createElement(BaseButton_1.default, Object.assign({}, props, { className: "group block flex-shrink-0 w-full" }),
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement(Avatar_1.default, { avatar: avatar }),
                react_1.default.createElement("div", { className: "flex flex-col items-start ml-3" },
                    react_1.default.createElement("p", { className: "dark:text-gray-300 text-gray-700 group-hover:text-gray-900 text-sm font-medium leading-5" }, title),
                    react_1.default.createElement("p", { className: clsx_1.default('text-gray-500 group-hover:text-gray-700 font-medium leading-4 transition duration-150 ease-in-out', title ? ' text-xs' : 'text-md') }, action))))));
}
exports.default = AvatarButton;
